import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=20f291f6&scoped=true"
import script from "./TeamView.vue?vue&type=script&lang=js"
export * from "./TeamView.vue?vue&type=script&lang=js"
import style0 from "./TeamView.vue?vue&type=style&index=0&id=20f291f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f291f6",
  null
  
)

export default component.exports